import CheckoutRequest from "@/entities/common/request/checkout_request"
import BaseLogic from "../base_logic"
import Poster from "@/util/poster"
import RemoteResult from "@/entities/common/remote_result"
import CheckoutOrder from "@/entities/common/checkout_order"
import RestPaths from "@/util/rest_paths"

export default class BezahlungWeiterleitenBestellungLogic extends BaseLogic {
  init(id: string) {
    var request = new CheckoutRequest()
    request.id = id

    Poster.postUser<RemoteResult<CheckoutOrder>>(
      RestPaths.paymentPaypalCheckout,
      request
    ).then((response) => {
      window.location.href =
        "https://www.sandbox.paypal.com/checkoutnow?token=" +
        response.data.payload.orderId
    })
  }
}
